import React, { Fragment } from "react";

import HeatEditor from "./HeatEditor.jsx";
import OpticalHeatEditor from "./OpticalHeatEditor.jsx";
import OpticalSmokeEditor from "./OpticalSmokeEditor.jsx";
import { RowHeader } from "../../DataTable.jsx";
import { MRK2_MODULE_DATA } from "../../const.js";

const EDITOR_MAPPING = {
    heat: HeatEditor,
    smoke: OpticalSmokeEditor,
    optoHeat: OpticalHeatEditor

}

export default function DeviceOptionsEditor(props) {
    let flags = MRK2_MODULE_DATA.find(d => d.id == props.deviceType).flags;
    let Editor = EDITOR_MAPPING[Object.keys(flags).find(f => flags[f])] || null;
    if (Editor == null) {
        return null;
    }
    return <Fragment>
        <RowHeader label="Device Settings"/>
        <Editor isDirty={props.isDirty} disabled={props.disabled} value={props.value} onChange={props.onChange} />
    </Fragment>
}